<template>
	<div class="basic_wrap">
		<div class="lan-box">
			<van-popover v-model="showPopover" trigger="click" placement="bottom-start" :offset="[0, 0]"
				:actions="actions" @select="onSelect">
				<template #reference>
					<div class="lan-label">
						<img :src="lan_ico" alt="">
						<span>{{ lan_num }}</span>
					</div>
				</template>
			</van-popover>
		</div>
		<div class="user-top">
			<!-- <img
        src="../images/login/logo.png"
        alt=""
      >
      <div class="user-name">
        B2B
      </div> -->
			<img src="../images/login/Snipaste2.png" alt="">
			<div class="user-name">
				国家开发银行
			</div>
			<div class="palace-welcome">推进精准扶贫 打赢脱贫攻坚战</div>
			<div class="bottom-size">国开行走出开发性金融脱贫攻坚新路子</div>
		</div>
		<!-- <div class="login_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{$t('register.register')}}
      </div>
    </div> -->
		<div class="login-main">
			<form class="form">
				<div class="cut_login" style="display: none;">
					<router-link to="/login">
						{{ $t('register.signIn') }}
						<div class="line" />
					</router-link>
					<router-link class="cur" to="/register">
						{{ $t('register.signUp') }}
						<div class="line" />
					</router-link>
				</div>
				<div class="cut_login" style="color: #e50113;">{{ $t('register.signUp') }}</div>

				<div class="item mt" style="padding-left: 10px;">
					<span class="icon">
						<img src="../images/login/email.png" alt="">
					</span>
					<input v-model.trim="data.mobile" type="text" class="inp" placeholder="请输入手机号">
				</div>
				<!-- <div class="item">
				<span class="icon">
					<img src="../images/login/p1.png" alt="">
				</span>
				<input type="text" class="inp" v-model.trim="data.name" placeholder="请输入用户名" />
			</div> -->
				<div class="item" style="padding-left: 10px;">
					<span class="icon">
						<img src="../images/login/lock.png" alt="">
					</span>
					<input v-model.trim="data.password" :type="password" class="inp"
						:placeholder="$t('register.password')">
					<div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd" />
				</div>
				<div class="item">
					<span class="icon">
						<img src="../images/login/lock.png" alt="">
					</span>
					<input v-model.trim="data.spassword" :type="password" class="inp"
						:placeholder="$t('register.passwordAgain')">
					<div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd" />
				</div>

				<!-- 			<div class="item">
				<input type="password" class="inp" v-model.trim="data.paypwd" placeholder="请输入支付密码" />
			</div>
			<div class="item">
				<input type="password" class="inp" v-model.trim="data.confirm_paypwd" placeholder="请再次输入支付密码" />
			</div> -->

				<div v-if="show_sms > 0" class="item">
					<input v-model.trim="data.code" type="text" class="inp" :placeholder="$t('register.code')">
					<van-count-down :time="time" class="btn get_captcha" @finish="timeCall">
						<template v-slot="timeData">
							<span @click="sendcode">{{
								timeData.seconds > 0
									? timeData.seconds
									: $t('register.sendCode')
							}}</span>
						</template>
					</van-count-down>
				</div>
				<div class="item">
					<span class="icon">
						<img src="../images/login/p2.png" class="people" alt="">
					</span>
					<input v-model.trim="data.invitation_code" type="text" class="inp" placeholder="请输入邀请码">
				</div>
				<div class="basic_btn sbtn" :class="data.mobile == '' ||
					data.password == ''
					//||data.code == ''
					? 'no_touch'
					: ''
					" @click="submit">
					{{ $t('register.signUpBtn') }}
				</div>
				<div style="text-align: right;">已有账号?<router-link to="/login" style="color: #e50113;">
						{{ $t('register.signIn') }}
						<div class="line" />
					</router-link></div>
			</form>
		</div>

		<van-dialog v-model="statement" confirm-button-color="#fb661e" :close-on-click-overlay="true"
			@click="privacyStatementHide" />
		<van-dialog v-model="agreement" confirm-button-color="#fb661e" :close-on-click-overlay="true"
			@click="agreementHider" />
		<div class="btns-grounp">
			<div v-if="msg_show" class="kefu-link" :class="show_kefu ? '' : 'kefu_hide'" @click="kefu_to">
				<img class="kefu_img" src="../images/new/kefu2.jpg">
				在线客服
			</div>
			<div v-if="msg_show" class="kefu-link" :class="show_kefu ? '' : 'kefu_hide'" @click="downloads">
				<img class="kefu_img" src="../images/new/download2.jpg">
				APP下载
			</div>
		</div>
		<!-- <div v-if="msg_show" class="kefu-link" :class="show_kefu ? '' : 'kefu_hide'" @click="kefu_to">
			<img class="kefu_img" src="../../views/images/user/kefu-ico.png">
		</div> -->
	</div>
</template>

<script>
import Vue from "vue";
import {
	CountDown,
	Checkbox,
	Dialog
} from "vant";
import Fetch from "../../utils/fetch";

Vue.use(CountDown)
	.use(Checkbox)
	.use(Dialog);

export default {
	name: "Register",
	data() {
		return {
			time: 0,
			agreement: false,
			statement: false,
			show_kefu: false,
			msg_show: true,
			show_sms: 0,
			password: "password",
			data: {
				password: "",
				spassword: "",
				mobile: "",
				invitation_code: "",
				code: "",
				agent: 10000
			},
			showPopover: false,
			actions: [
				{ text: '中国', icon: require('../images/language/zh_cn.png'), },
				{ text: 'English', icon: require('../images/language/en_us.png'), },
				{ text: '日本', icon: require('../images/language/ja_jp.png'), },
				{ text: 'Brasil', icon: require('../images/language/ko_kr.png'), },
				{ text: 'Việt Nam', icon: require('../images/language/vi_vn.png'), },
				{ text: 'Malaysia', icon: require('../images/language/th_th.png'), },
				{ text: 'ประเทศไทย', icon: require('../images/language/ms_my.png'), },
				{ text: 'Indonesia', icon: require('../images/language/zh_hk.png'), },
			],
			lan_num: '中国',
			lan_ico: require('../images/language/zh_cn.png'),
			config: {}
		};
	},
	created() {
		this.$parent.footer("user", false);
		this.getparams();
		// 安卓返回IMEI，苹果返回UID值
		/*BSL.PhoneID('callName');
		window.callName = this.methodName;
		// 获取手机OAID
		BSL.GetOAID('getExternalInfo');
		window.getExternalInfo = this.getExternalInfoData; */
	},
	mounted() {
		if (this.$route.query.agent) {
			localStorage.setItem('agent', this.$route.query.agent);
			this.data.agent = this.$route.query.agent;
		} else {
			if (localStorage.getItem('agent')) {
				this.data.agent = localStorage.getItem('agent');
			}
		}
		var that = this;
		document.body.addEventListener(
			"scroll",
			function () {
				if (!that.show_kefu) {
					return;
				}
				that.show_kefu = false;
			},
			false
		);
		document.addEventListener(
			"click",
			function (ev) {
				if (ev.target.className != "kefu_img") {
					that.show_kefu = false;
				}
			},
			false
		);
		Fetch('/index/webconfig', {
			type: 'web'
		}).then(res => {
			this.config = res.data
			this.show_sms = res.data.sms_verify
		})
	},
	methods: {
		onSelect(action) {
			console.log(action)
			this.lan_ico = action.icon
			this.lan_num = action.text
			let lang
			if (action.text == "中国") {
				lang = "zh_cn"
			}
			if (action.text == "English") {
				lang = "en_us"
			}
			if (action.text == "日本") {
				lang = "ja_jp"
			}
			if (action.text == "Brasil") {
				lang = "ko_kr"
			}
			if (action.text == "Việt Nam") {
				lang = "vi_vn"
			}
			if (action.text == "Malaysia") {
				lang = "th_th"
			}
			if (action.text == "ประเทศไทย") {
				lang = "ms_my"
			}
			if (action.text == "Indonesia") {
				lang = "zh_hk"
			}
			this.$i18n.locale = lang;
			localStorage.setItem("lang", lang);
		},
		downloads() {
			this.$router.push("/downloadApp");
		},
		kefu_to() {
			Fetch('/user/system_info').then((r) => {
				window.location.href = r.data.service
				// window.open(r.data.service, '_blank');
			});
			// this.$router.push("/kefu");
			// if (this.show_kefu) {
			// 	this.$router.push("/kefu");
			// }
			// this.show_kefu = !this.show_kefu;
		},
		showPwd() {
			if (this.password == "password") {
				this.password = "text";
			} else {
				this.password = "password";
			}
		},
		methodName(r) {
			this.data.imei = r;
		},
		getExternalInfoData(info) {
			var info = JSON.parse(info);
			console.log(info);
			if (info.code == 0) {
				this.data.oaid = info.oaid;
			}
		},
		getparams() {
			var m = this.$route.query.m;
			this.data.invitation_code = m;
		},
		timeCall() {
			this.is_send = false;
			this.time = 0;
		},
		sendcode() {
			if (this.is_send) {
				return;
			}

			if (!this.data.mobile) {
				this.$toast(this.$t('register.phoneEmpty'));
				return;
			}

			this.is_send = true;

			Fetch("/index/register_code", {
				mobile: this.data.mobile,
			})
				.then(() => {
					this.time = 60 * 1000;
					this.$toast({
						background: "#07c160",
						message: this.$t('register.sendSuccess'),
					});
				})
				.catch(() => {
					this.is_send = false;
				});
		},
		submit() {
			if (!this.data.mobile) {
				this.$toast({
					className: "toastName",
					message: this.$t('register.phoneEmpty'),
				});
				return false;
			}
			if (!this.data.password) {
				this.$toast({
					className: "toastName",
					message: this.$t('register.passwordEmpty'),
				});
				return false;
			}
			if (!this.data.spassword) {
				this.$toast(this.$t('register.passwordAgainEmpty'));
				return false;
			}

			if (!this.data.code && this.config.sms_verify) {
				this.$toast({
					className: "toastName",
					message: this.$t('register.codeEmpty'),
				});
				return false;
			}
			if (this.data.password != this.data.spassword) {
				this.$toast(this.$t('register.passwordError'));
				return false;
			}
			if (!/^\d{6}$/.test(this.data.invitation_code)) {
				this.$toast('请填入正确邀请码');
				return false;
			}


			Fetch("/index/register", {
				...this.data,
			}).then((res) => {
				if (res.data.token) {
					localStorage.setItem('token', res.data.token);
				}
				this.$toast({
					className: "toastName",
					message: this.$t('register.signUpSuccess'),
				});
				this.$router.replace("/");
			});
		},
		userAgreement() {
			this.agreement = true;
		},
		agreementHider() {
			this.agreement = false;
		},
		privacyStatement() {
			this.statement = true;
		},
		privacyStatementHide() {
			this.statement = false;
		},
	},
};
</script>

<style lang="less" scoped>
.user-top {
	display: flex;
	flex-direction: column;
	// justify-content: center;
	align-items: center;
	padding: 90px 0 10px 0;
	color: #ffffff;

	img {
		width: 60px;
		height: 60px;
		border-radius: 5px;
		// border: 2px solid #ffffff;
	}

	.user-name {
		font-size: 36px;
		margin: 20px 0;
		background-color: #e50113;
		background-clip: text;
		color: transparent;
		font-weight: bold;
	}
}

.basic_wrap {
	position: relative;
	background: url(../images/user/8b4.jpg) no-repeat center;
	background-size: 112% 102%;
	height: 100vh;

	.lan-box {
		display: none;
		position: absolute;
		top: 10px;
		left: 25px;
	}
}


.login_bg {
	width: 100%;
	overflow: hidden;

	.language {
		position: absolute;
		top: 4px;
		right: 0;
		height: 36px;

		img {
			height: 100%;
		}
	}
}

.login-main {
	padding: 0 25px;
}

.basic_wrap .form {
	// background: rgba(255, 255, 255, 1);
	// box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
	// border-radius: 13px;
	padding: 31px 24px 24px 24px;
}

.cut_login {
	width: 207px;
	line-height: 25px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 18px;
	text-align: center;
	margin: 0 auto;

	a {
		width: 50%;
		padding-bottom: 10px;
		color: #ceced0;
		position: relative;

		.line {
			width: 100%;
			height: 1px;
			position: absolute;
			left: 0;
			bottom: 0;
			background-color: #f2f2f2;
		}
	}

	a.cur {
		color: #f12211;

		.line {
			height: 2px;
			background-image: linear-gradient(to right, #f12211, #f18a11);
		}
	}
}

.mt {
	margin-top: 20px;
}

.item {
	background-color: #e9e9e9;
	height: 48px;
	padding: 0 15px;
	// border: 1px solid #dfdfdf;
	font-size: 14px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 15px;

	.icon {
		width: 20px;
		min-width: 20px;
		text-align: center;
		height: 20px;

		img {
			width: 20px;
			height: 20px;
		}
	}

	input {
		height: 20px;
		margin-left: 7px;
		flex: 1;
	}
}

.item_reset_pwd {
	font-size: 14px;
	color: #3d96ff;
	text-align: right;
	margin-top: 10px;
	line-height: 20px;
}

.van-checkbox {
	margin-top: 20px;
}

/deep/ .van-checkbox__icon--checked .van-icon {
	color: #fff;
	background-color: #ff5a50;
	border-color: #ff5a50;
}

/deep/ .van-checkbox__label {
	color: #ff5a50;
}

.reset_pwd {
	color: #333;
	margin-top: -20px;
	display: block;
}

.basic_btn {
	margin: 20px auto 20px auto;
	width: 100% !important;
	border-radius: 0px !important;
}

.lan-label {
	display: flex;
	align-items: center;
	white-space: nowrap;
	height: 48px;
	min-width: 24px;
	height: 25px;
	padding-right: 8px;
	border-radius: 25px;
	background-image: linear-gradient(to right, #ffff80, #ffffff);
}

.lan-label span {
	display: inline-block;
	margin-left: 3px;
}

.lan-label img {
	width: 22px;
	height: 22px;
}


.btns-grounp {
	display: flex;
	gap: 13px;
	justify-content: center;
}

.kefu-link {
	// padding: 20px;
	text-align: center;
	background: linear-gradient(90deg, #FFE4B0 0%, #FFD18C 100%);
	gap: 8px;
	width: 30%;
	display: flex;
	align-items: center;
	border-radius: 5px;
	height: 40px;
	justify-content: center;
	height: 33px;
	font-size: 12px;
	color: black;
	font-weight: bold;
	cursor: pointer;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.kefu-link img {
	border-radius: 10px;
	width: 20px;
	height: 20px;
}

// .kefu-link {
// 	padding: 20px;
// 	text-align: center;
// }

// .kefu-link img {
// 	width: 35px;
// }

.show-body {
	padding: 30px 30px 15px 30px;
	text-align: center;
}
</style>
<style>
.van-popover {
	width: 120px;
}

.van-popover__action {
	height: 40px;
	line-height: 40px;
}

.van-popover .van-popover__action-text::after {
	left: -100px;
}

.van-popover__action-icon {
	border: 1px solid #ececec;
	border-radius: 30px;
}

.van-popover__action {
	padding: 0 10px;
}

.palace-welcome {
	width: 300px;
	height: 50px;
	/* padding: 5px; */
	/* background: #9e2b27; */
	color: #e50113;
	border: 2px solid #e50113;
	border-radius: 5px;
	box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
	text-align: center;
	font-family: "楷体", "STKaiti", serif;
	font-size: 16px;
	font-weight: bold;
	display: flex;
	align-items: center;
	justify-content: center;
}

.palace-welcome::before,
.palace-welcome::after {
	content: "★";
	color: #e50113;
	font-size: 15px;
	margin: 0 10px;
}

.palace-welcome::before {
	margin-right: 10px;
}

.palace-welcome::after {
	margin-left: 10px;
}

.bottom-size {
	margin: 10px 0;
	color: black;
	font-size: 15px;
}
</style>
